<div class="row row-cols-1 row-cols-md-3 row-cols-lg-4 p-2">
  @for (alert of sosAlerts; track alert; let i = $index) {
    <div>
      <div class="card p-2 border-danger">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="fw-bold">
              {{ alert.user_name }}
            </div>
            <div class="small-font text-secondary">
              {{ alert?.updated_at | customDate: "d MMM y HH:mm" }}
            </div>
          </div>
          @if (!alert?.showGps) {
            <div (click)="showGps(i)">
              <i class="fa-solid fa-circle-info"></i>
            </div>
          }
        </div>
        <div
          [ngClass]="alert?.mobile_number ? 'row row-cols-2 my-2' : 'row my-2'"
        >
          <div
            (click)="
              selectedAlert = alert;
              openAlertTemplate(acknowledgeTemplate, alert)
            "
          >
            <button class="btn btn-primary btn-lg w-100 fw-bold">
              Acknowledge
            </button>
          </div>
          @if (alert?.mobile_number) {
            <div>
              <a href="tel:{{ alert?.mobile_number }}" class="me-2">
                <button class="btn btn-success btn-lg w-100 fs-5 fw-bold">
                  <i class="fa-solid fa-phone-volume text-light me-2"></i> CALL
                </button>
              </a>
            </div>
          }
        </div>
        @if (alert?.showGps) {
          <gtapp-map-leaflet
            [latLon]="alert?.gps"
            [mapId]="'smallMapId' + alert?.userId"
          ></gtapp-map-leaflet>
        }
      </div>
    </div>
  }
</div>
@if (!selectedEvent || largeView) {
  <gtapp-gt-table
    [desktopTableBackendData]="sosAlertHistoryData"
    [desktopTableDetails]="userEventDetailsTableView"
    [otherParams]="otherParamsSOSAlertsHistory"
    [tableStyle]="tableStyle"
    (rowClick)="onTableRowClickSOSAlertsHistory($event)"
    (sortColumn)="sortColumnSOSAlertsHistory($event)"
    (searchColumn)="searchColumnSOSAlertsHistory($event)"
    (paginationChange)="onChangePaginationSOSAlertsHistory($event)"
  ></gtapp-gt-table>
}
@if (selectedEvent) {
  <gtapp-selected-event-detail
    [selectedEvent]="selectedEvent"
    selectedEventFrom="sosAlert"
    [userEventDetailsTableView]="userEventDetailsTableView"
    [extraCheck]="true"
    (goBack)="hideDetails()"
  ></gtapp-selected-event-detail>
}

<ng-template #acknowledgeTemplate let-acknowledgeTemplate="dialogRef">
  <div class="dialog-box p-2 card">
    <div class="card-header">
      <div class="d-flex align-items-center">
        <div class="flex-grow-1">Acknowledge SOS</div>
        @if (isAlertActive) {
          <div>
            <button class="btn btn-info btn-sm" (click)="muteAlert()">
              <i class="fas fa-volume-mute text-white"></i>
            </button>
          </div>
        }
      </div>
    </div>
    @if (guardAlertData) {
      <div class="mb-2">
        <gtapp-map-leaflet
          [latLon]="guardAlertData?.gps"
          [mapId]="'alertMapId'"
        ></gtapp-map-leaflet>
      </div>
    }
    <form [formGroup]="acknowledgeForm">
      <div class="d-flex">
        <div class="d-inline ms-1 fw-semibold">Guard Contacted?</div>
        <div class="d-inline" data-toggle="buttons">
          <label class="mx-2">
            <input type="radio" formControlName="inquired" [value]="true" />
            Yes
          </label>
          <label class="mx-2">
            <input type="radio" formControlName="inquired" [value]="false" />
            No
          </label>
        </div>
      </div>

      <div class="col mt-2">
        <textarea
          class="form-control"
          placeholder="Actions Taken / Details"
          cols="20"
          rows="5"
          wrap="hard"
          maxlength="900"
          formControlName="comment"
        ></textarea>
      </div>
    </form>

    <div class="row my-2">
      <div class="col">
        <button
          class="btn btn-dark btn-lg w-100"
          (click)="acknowledgeTemplate.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="acknowledgeTemplate.close(); acknowledgeAlert()"
          [disabled]="!acknowledgeForm.valid"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</ng-template>
